import React from "react";

export interface ButtonBigProps {
  label: string,
  onclick?: (callback: any) => void,
  disabled?: boolean,
  height?: string,
  type?: 'submit' | 'reset' | 'button',
  inactive?: boolean,
  icon?: string,
  className?: string,
  classNames?: string,
  active?: boolean,
  withSpacer?: boolean,
  children?: React.ReactNode;
  href?: string,
  key?: string|number,
}

const ButtonBig: React.FC<ButtonBigProps> = ({
                                               label = 'Label',
                                               onclick,
                                               disabled = false,
                                               height = 'normal',
                                               type = 'button',
                                               inactive = false,
                                               icon,
                                               className,
                                               classNames = 'btn btn-success waves-effect waves-ga auto-height',
                                               active,
                                               withSpacer = false,
                                               children,
                                               href
                                             }) => {

  if (height === 'small') {
    classNames += ' btn-small';
  }

  if (inactive) {
    classNames += ' inactive';
  }

  if (active) {
    classNames += ' active';
  }

  if (withSpacer) {
    classNames += ' with-spacer';
  }

  if (className) {
    classNames += ' ' + className;
  }

  if (href) {
    return (
      <a href={href} className={classNames}>
        {icon && <i className="material-icons inline-icon">{icon}</i>}
        {label}{children}
      </a>
    );
  }

  return (
    <button onClick={onclick} disabled={disabled} type={type} className={classNames}>
      {icon && <i className="material-icons inline-icon">{icon}</i>}
      {label}{children}
    </button>
  );
};

export default ButtonBig;